var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-tablet"},_vm._l((_vm.sections),function(section,i){return _c('SectionItem',{key:i,attrs:{"section":section}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }